import script from "./MetaKoronaView.vue?vue&type=script&setup=true&lang=js"
export * from "./MetaKoronaView.vue?vue&type=script&setup=true&lang=js"

import "./MetaKoronaView.vue?vue&type=style&index=0&id=4db7d726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db7d726"]])

export default __exports__